export interface IShortCommand {
  command: EShortCommand;
  name: string;
  icon: unknown;
  prompt: string;
}

export enum EShortCommand {
  VIDEO_CAPTURE = "videoCapture",
  AMAZING_CAPTURE = "amazingCapture",
  DETAIL_DESCRIPTION = "detailDescription",
  AUDIO_ANALYSIS = "audioAnalysis",
}
